module.exports = __webpack_public_path__ + "assets/515ed2c1d35dbf31e389293d6dc79b00.png";